import { WorkspaceRole, WorkspaceSeatType } from 'models/user/userWorkspaceDTOs'

import { useMemo } from 'react'
import { useUserData } from 'components/contexts/UserDataContext'

/**
 * Hook to derive the current user's role in their active workspace.
 * Provides boolean flags for admin, member, and restricted/sponsored access.
 */
export const useWorkspaceRoles = () => {
  const { currentUserWorkspace, currentUserWorkspaceMembership } = useUserData()

  return useMemo(
    () => {
      const isWorkspaceMember = currentUserWorkspace?.role === WorkspaceRole.MEMBER
      const isWorkspaceRestricted = currentUserWorkspace?.seatType === WorkspaceSeatType.RESTRICTED

      return {
        isWorkspaceAdmin: currentUserWorkspace?.role === WorkspaceRole.ADMIN,
        isWorkspaceMember,
        isWorkspaceSponsored: currentUserWorkspace?.seatType === WorkspaceSeatType.SPONSORED,
        isWorkspaceRestricted,
        /**
         * A non-admin member on a restricted (free) seat (ISSUE-2488). Restricted members must not see
         * the other members of their workspace, so the Members page/list is hidden entirely for them.
         * A Restricted Admin is intentionally excluded — admins keep the Members page so they can invite.
         */
        isRestrictedMember: isWorkspaceMember && isWorkspaceRestricted,
        isPropstackLinked: !!currentUserWorkspaceMembership?.propstackLinked,
      }
    },
    [currentUserWorkspace?.role, currentUserWorkspace?.seatType, currentUserWorkspaceMembership?.propstackLinked]
  )
}
